module.exports = __webpack_public_path__ + "static/media/step-indicator-2of2.d6c8138e.svg";